import { getColorModeQueryParam } from 'braid-design-system/color-mode/query-param';

import type { AppContextType } from '../components/AppContext';
import type { Experience } from '../types';

import getClientDomain from './getClientDomain';
import { getLanguageSuffix } from './getLanguageSuffix';
import getMobileLinkSuffix from './getMobileLinkSuffix';

export default (
  path: string,
  context: AppContextType,
  pathExperience: string = '',
): string => {
  const { language, clientOrigin, experience, isMobileClient, locale } =
    context;
  const inputExperience = (pathExperience || experience) as Experience;
  const languageSuffix = getLanguageSuffix(
    language,
    locale,
    inputExperience,
    path,
  );
  const baseDomain = getClientDomain(context, inputExperience);

  // We will get the domain based URL suffixes here
  const mobileSuffix = isMobileClient ? getMobileLinkSuffix(path) : '';

  const mobielColorModePreference = getColorModeQueryParam();
  const queryString =
    isMobileClient && mobielColorModePreference
      ? `&${mobielColorModePreference}`
      : '';

  const baseOrigin = baseDomain
    ? `https://${baseDomain}${languageSuffix}`
    : clientOrigin;

  // As we now will be modifying the path completely, we need to prepare the path appropriately to flourish the needful link
  const preparedPath = mobileSuffix.length > 0 ? mobileSuffix : path;

  return `${baseOrigin}${preparedPath}${queryString}`;
};
